/**
 * Sticker de una card: el primer valor con contenido de `stickers[]`. El resto
 * de la lista se ignora a propósito (las cards solo muestran uno). Devuelve
 * `undefined` si el campo llega ausente, `null`, vacío o con solo cadenas
 * en blanco — renderizado defensivo, la card no pinta nada.
 */
export function resolveCardSticker(stickers: readonly string[] | null | undefined): string | undefined {
  if (!Array.isArray(stickers)) return undefined
  for (const sticker of stickers) {
    if (typeof sticker !== 'string') continue
    const text = sticker.trim()
    if (text) return text
  }
  return undefined
}
